import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const hiv: AnswerPathTreeNode = {
  path: 'hiv',
  children: [{ path: 'details', nodeId: NodeIds.healthInsuredHivDetails }],
};
